module.exports = __webpack_public_path__ + "static/carioca-5a89652cf82b7493382d85c925dd2ab3.jpg";